import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";

const countyChartFunc = (divRef, ndx) => {
    const dimension = ndx.dimension((d) => d.county);

  const selectChart = dc.selectMenu(divRef);
  selectChart
    .dimension(dimension)
    .group(dimension.group().reduceCount())
    .on("filtered", function (chart, filter) {
      var sel = chart.filterPrinter()(chart.filters());
      window.ADMINLEVEL = sel
      // console.log("selected filters are:" + sel);
    })
    .title((d) => d.key)
    .controlsUseVisibility(true);

  return selectChart;
};

export const SelectCountyChart = (props) => (
  <ChartTemplate
    chartFunction={countyChartFunc}
    // title="Gender of Financing Recipient"
    name="Select Administration Level"
  />
);
